module.exports = __webpack_public_path__ + "static/team-5-1942fcb9cea3c8ae6ef6ba36e6494a7b.jpg";